export default {
    U: (url, pre = '/api/h5/v1/common/', domain = window.g.BASE_URL) => {
        return domain+pre+url;
    }
}
